import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import Model from "@ckeditor/ckeditor5-ui/src/model";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import FileDialogButtonView from '@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview';
import {
    addListToDropdown,
    createDropdown
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import SplitButtonView from "@ckeditor/ckeditor5-ui/src/dropdown/button/splitbuttonview";
import Icon from './../icons/icon_add_vrezka.svg';
import iconQuot from './../icons/icon-blockquote.svg';
import quoteIcon from '@ckeditor/ckeditor5-core/theme/icons/quote.svg';
import iconSpravkaFull from './../icons/icon_spravka_full.svg';
import iconMedic from './../icons/icon_med.svg';
import iconUpdate from './../icons/icon_update_material.svg';
import iconHorizontal from './../icons/horizontalline.svg';
import iconNewsInNews from './../icons/icon_vrezka.svg';
import iconNewsInNewsTwo from './../icons/icon_vrezka-min.svg';


export default class DropDownInsert extends Plugin {
    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("DropDownInsert", locale => {
            const dropdownView = createDropdown(locale, SplitButtonView);
            dropdownView.buttonView.actionView.set({
                withText: false,
                label: "Врезки",
                icon: Icon,
                tooltip: true
            });
            dropdownView.class = 'comp_g';
            const items = new Collection();

            items.add({
                type: "button",
                model: new Model({
                    id: 'quot',
                    withText: false,
                    icon: quoteIcon,
                    label: "Цитата обычная",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'spravkaFull',
                    withText: false,
                    icon: iconSpravkaFull,
                    label: "Справка на ширину колонки",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'newsInNews',
                    withText: false,
                    icon: iconNewsInNews,
                    label: "Вставка «В тему»",
                    tooltip: true
                })
            });

            items.add({
                type: "button",
                model: new Model({
                    id: 'newsInNewsTwo',
                    withText: false,
                    icon: iconNewsInNewsTwo,
                    label: "Вставка «В тему» (min)",
                    tooltip: true
                })
            });

            items.add({
                type: "button",
                model: new Model({
                    id: 'medic',
                    withText: false,
                    icon: iconMedic,
                    label: "Мед. плашка",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'updateMaterial',
                    withText: false,
                    icon: iconUpdate,
                    label: "Update материала",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'horizontal',
                    withText: false,
                    icon: iconHorizontal,
                    label: "Горизонтальная линия",
                    tooltip: true
                })
            });

            addListToDropdown(dropdownView, items);

            dropdownView.on('execute', (eventInfo) => {
                const {id, label} = eventInfo.source;

                if (id === 'medic') {
                    editor.execute('insertMedic');
                } else if (id === 'spravkaFull') {
                    editor.execute('insertSpravka');
                } else if (id === 'spravkaLeft') {
                    editor.execute('insertSpravkaLeft');
                } else if (id === 'quot') {
                    editor.execute('blockQuote');
                } else if (id === 'persona') {
                    editor.execute('personaInsert');
                } else if (id === 'updateMaterial') {
                    editor.execute('insertUpdateMaterial');
                } else if (id === 'quot_hard') {
                    editor.execute('NewBlockquote');
                } else if (id === 'horizontal') {
                    editor.execute('horizontalLine');
                } else if (id === 'napravah') {
                    editor.execute('NaPravah');
                } else if (id === 'newsInNews') {
                    editor.execute('insertNewsInText');
                }  else if (id === 'newsInNewsTwo') {
                    editor.execute('insertNewsInTextTwo');
                }
            });


            return dropdownView;
        });
    }
}
